import { useEffect, useState } from "react";
import LoadingSpinner from "../../utils/LoadingSpinner";
import { updateDelegate } from "../../utils/AWSAPI";
import { useTranslation } from 'react-i18next';
import '../../assets/css/Settings.css'
import { loadLimitedLocations } from "../../utils/Utils";
import i18n from "../Translations/i18n/i18n";

function Settings() {
  const { t } = useTranslation();

  // DATA API
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  // Are we showing a modal? I.E: Error, success.
  const [isModalShowing, setModalShowing] = useState(false);
  const [isModalUncloseable, setModalUncloseable] = useState(false);

  const [modalHeader, setModalHeader] = useState(t('Loading...'));
  const [modalBody, setModalBody] = useState(<></>);
  const [modalFooter, setModalFooter] = useState(<></>);

  const closeModal = () => {
    setModalShowing(false);
  };

  const Modal = () => {
    return (
      <div className="modal show">
        <div className="modal-content">
          <div className="modal-header">
            <h4>{modalHeader}</h4>
            {!isModalUncloseable && (
              <span className="close" onClick={closeModal}>&times;</span>
            )}
          </div>
          <div className="modal-body">{modalBody}</div>
          <div className="modal-footer">{modalFooter}</div>
        </div>
      </div>
    );
  };


  const updateModal = (header, body, footer) => {
    setModalShowing(!isModalShowing);
    setModalHeader(header);
    setModalBody(body);
    setModalFooter(footer);
    setModalShowing(true);
  }

  
const getEmployeeIdForDelegate = () => {
  const clean = (value) => {
    if (!value) return "";
    if (value === "undefined") return "";
    if (value === "null") return "";
    if (value.trim() === "") return "";
    return value;
  };

  const rawEid = clean(localStorage.getItem("user_eid"));
  if (rawEid) return rawEid;            //  SSO McD:  EID

  const fallbackUser = clean(localStorage.getItem("user_identifier"));
  return fallbackUser;                  //  Fujitsu: email
};

const normalizeDelegateResponse = (resp) => {
  if (resp === true) {
    return { ok: true };
  }

  if (resp && resp.status === "failure") {
    return {
      ok: false,
      message: resp?.error?.message || "Failed to update delegate",
      detail: resp?.error?.detail || ""
    };
  }

  if (resp?.Error) {
    return { ok: false, message: resp.Error, detail: "" };
  }

  return { ok: false, message: "Unexpected response from server", detail: JSON.stringify(resp) };
};

const submitUpdateDelegate = async (index) => {
  closeModal();

  const newState = !toggleStates[index];
  const delegateStatus = newState ? "Yes" : "No";
  const employeeId = getEmployeeIdForDelegate();

  if (!employeeId) {
    return updateModal(
      t("Error"),
      t("No identifier available for delegate update.")
    );
  }

  setToggleStates((prev) => {
    const copy = [...prev];
    copy[index] = newState;
    return copy;
  });

  try {
    const resp = await updateDelegate(
      data[index].MCID.S,
      employeeId,
      delegateStatus
    );

    console.log("updateDelegate response:", resp);

    const result = normalizeDelegateResponse(resp);

    if (!result.ok) {
      setToggleStates((prev) => {
        const copy = [...prev];
        copy[index] = !newState;
        return copy;
      });

      return updateModal(
        t("Error"),
        <>
          <div><b>{result.message}</b></div>
          {result.detail && <div style={{ marginTop: 8 }}>{result.detail}</div>}
        </>,
        <button type="button" onClick={closeModal}>{t("Ok")}</button>
      );
    }

    return updateModal(
      t("Success"),
      t("UpdatedWatchList"),
      <button type="button" onClick={closeModal}>{t("Ok")}</button>
    );

  } catch (err) {
    console.error("updateDelegate error:", err);

    setToggleStates((prev) => {
      const copy = [...prev];
      copy[index] = !newState;
      return copy;
    });

    const serverMsg =
      err?.response?.data?.error?.message ||
      err?.response?.data?.message ||
      err?.message ||
      "Request failed";

    const serverDetail =
      err?.response?.data?.error?.detail ||
      err?.response?.data?.detail ||
      "";

    return updateModal(
      t("Error"),
      <>
        <div><b>{serverMsg}</b></div>
        {serverDetail && <div style={{ marginTop: 8 }}>{serverDetail}</div>}
      </>,
      <button type="button" onClick={closeModal}>{t("Ok")}</button>
    );
  }
};





  useEffect(() => {
    const fetchData = async () => {
      try {
        const locations = await loadLimitedLocations("True", localStorage.getItem("user_identifier"));
        if (locations.Error) {
          setModalUncloseable(true)
          return updateModal("Error", t("Couldn't fetch locations."));
        }
        setData(locations.data.Items);
        setLoading(false);
      } catch (err) {
        console.log(err);
      }
    }
    if (isLoading) {
      fetchData();
    }
  }, [isLoading]);

  const [toggleStates, setToggleStates] = useState([]);

  const toggleButton = (index) => {
    setModalHeader(t('Are you sure?'));
    setModalBody(t('ToggleConfirmation') + data[index].MCName.S + "?");
    setModalFooter(
      <>
        <button
          type="button"
          onClick={() => submitUpdateDelegate(index)}
        >
          {t('Yes')}
        </button>
        <button
          type="button"
          onClick={closeModal}
        >
          {t('No')}
        </button>
      </>
    );
    setModalShowing(true);
  };

  useEffect(() => {
    const loadLanguage = () => {
      const language = localStorage.getItem("language");
      if (language) {
        i18n.changeLanguage(language);
      }
    };
    loadLanguage();
  }, []);

useEffect(() => {
  if (!data) return;

  setToggleStates(prev => {

    if (prev.length > 0) return prev;

    return data.map(item => {
      const raw = item.Notifications?.S;

      console.log("Notifications.S raw for", item.MCName?.S, "=>", raw);

      if (typeof raw === "boolean") {
        return raw;
      }

      if (typeof raw === "string") {
        return raw.toLowerCase() === "true";
      }

      return false;
    });
  });
}, [data]);

  const handleLanguageChange = (event) => {
    const selectedLanguage = event.target.value;
    localStorage.setItem("language", selectedLanguage);
    i18n.changeLanguage(selectedLanguage);
    setTimeout(() => {
      window.location.reload();
    }, 0);
  };

  const isStoreAccount = () => {
    return localStorage.getItem("user_store_account") === "true";
  }

  return (
    <div className='App'>
      <LoadingSpinner show={isLoading} />

      {isModalShowing && (
        <Modal />
      )}

      <div className="settings-grid">
        <h3>{t('YourProfile')}</h3>
        <table>
          <tr>
            <td><b>{t('UserIdentifier')}</b></td>
            <td>{localStorage.getItem("user_identifier")}</td>
          </tr>
          <tr>
            <td><b>{t('PowerUserStatus')}</b></td>
            <td>{localStorage.getItem("user_power_user") == "true" ? "True" : "False"}</td>
          </tr>
          <tr>
            <td><b>{t('StoreAccountStatus')}</b></td>
            <td>{localStorage.getItem("user_store_account") == "true" ? "True" : "False"}</td>
          </tr>
          <tr>
            <td><b>{t('Language')}</b></td>
            <td>
              <select name='language' value={i18n.language} onChange={handleLanguageChange}>
                <option value="fq">{t('french')}</option>
                <option value="en">{t('english')}</option>
              </select>
            </td>
          </tr>
        </table>

        {data && !isStoreAccount() && (
          <div>
            <br></br>
            <hr></hr>

            <h3>{t('WatchList')}</h3>

            <table>
              <thead>
                <tr>
                  <th>{t('StoreName')}</th>
                  <th>{t('EmailNotificationStatus')}</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.MCName.S}</td>
                    <td>
                      <button className={toggleStates[index] ? 'toggle on' : 'toggle off'} onClick={() => toggleButton(index)}>
                        {toggleStates[index] ? 'ON' : 'OFF'}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default Settings;